
import {startAfter,endAt,onSnapshot,startAt,endBefore,query,Unsubscribe,QueryDocumentSnapshot,orderBy, doc, getDoc} from "firebase/firestore"
import { Component, Mixins, Watch  } from "vue-property-decorator";
import ModalConfirm from "@/components/ModalConfirm.vue";
import ModalAlert from "@/components/ModalAlert.vue";
import Common from '@/mixins/common';
import FullCalendar from '@fullcalendar/vue'
import {CalendarOptions, DateSelectArg, DatesSetArg, EventInput} from '@fullcalendar/core'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid';
import listPlugin from '@fullcalendar/list';
import interactionPlugin from '@fullcalendar/interaction'
import luxon2Plugin from '@fullcalendar/luxon2'
import jaLocale from '@fullcalendar/core/locales/ja';
import {toHanAscii} from 'jaconv'
import { httpsCallable } from "firebase/functions";
import { functions } from "@/scripts/firebase";
import { GetCalendarArg, GetCalendarRes, EventData, SchedulingSheet, PostStatus} from "@/common-datatypes"
import { ValidationObserver } from "vee-validate";
import { NoticeProps } from "@/scripts/datatypes";
import { ValidationFlags } from "vee-validate/dist/types/types"
import TemplateMembers from "@/components/TemplateMembers.vue";
import { DateTime } from "luxon";

@Component({
  components: {
    ModalConfirm,
    ModalAlert,
    FullCalendar,
    TemplateMembers
  }
})

export default class EditScheduling extends Mixins(Common) {
  eventsObservers: Unsubscribe[] = []

  disabledEditSchedulingSheet = true

  isLoading = false

  showModalAlert = false

  notice = {} as NoticeProps

  templateExample = ''


  alert = {title: '', message: ''}

  postStatuses(){
    if(this.$te('event.postStatus')){
      return this.$t('event.postStatus') as unknown as PostStatus
    }
    return undefined
  }

  schedulingSheetExamples(){
    if(this.$te('schedulingSheet')){
      return this.$t('schedulingSheet') as unknown as string[]
    }
    return undefined
  }
  
  timeZone = ''

  rawEvents: EventData[] = []
  currentEvents: EventData[] = []

  iCalEvents: EventInput[] = []

  get calendarApi(){
    return (this.$refs.fullCalendar as InstanceType<typeof FullCalendar>).getApi()
  }

  get validationObserver(){
    return (this.$refs.validationObserver as InstanceType<typeof ValidationObserver>)
  }


  calendarOptions: CalendarOptions = {
    plugins:  [listPlugin ,luxon2Plugin, timeGridPlugin, dayGridPlugin, interactionPlugin ] ,
    headerToolbar: {
      left: 'prev,next',
      center: 'title',
      right: 'timeGridWeek,listMonthCustom'
    },
    views: {
      listMonthCustom: {
        type: 'listMonth',
        duration: { days: 365},
        titleFormat: () => {
          return this.$t('schedule.list') as string
        }
      }
    },
    eventClassNames: (content) => {
      const classNames = []
      const exProps = content.event.extendedProps

      if(! exProps.docId){
        classNames.push('fc-event-imported')
      }

      if(exProps.status){
        classNames.push('fc-event-status-' + exProps.status)
      }
      if(exProps.postStatus){
        classNames.push('fc-event-poststatus-' + exProps.postStatus)
      }
      return classNames
    },
     aspectRatio: (() => {
      return window.innerWidth / window.innerHeight
    })(),
    windowResize: (arg) => {
      arg.view.calendar.setOption('aspectRatio', window.innerWidth / window.innerHeight)
    },
    validRange: {
      start: DateTime.now().plus({day: 1}).toJSDate()
    },
    windowResizeDelay: 300,
    dayMaxEvents: true,
    eventMaxStack: 3,
    firstDay: 1,//Monday
    navLinks: true,
    selectable: true,
    initialView: 'listMonthCustom',
    locales: [jaLocale],
    timeZone: undefined,
    locale: this.lang,
    //dateClick: this.handleDateClick,
    //eventClick: this.handleEventClick,
    select: this.handleEventSelect,
    eventTimeFormat: { hour12: false, hour: '2-digit', minute: '2-digit', timeZoneName: undefined },//timeZoneName: 'short'
    eventStartEditable: false,
    eventDurationEditable: false,
    //eventDrop: this.handleEventDrop,
    //eventDragStart: this.handleDragStart,
    datesSet: this.handleCalendarDatesSet,
    rerenderDelay: 0
    //eventsSet: this.handleEventsSet,
  //  viewClassNames: 'is-loading'
  }

  Loading = false

  Timer: number | undefined

  @Watch('templateExample')
  changeSheetExample(example: string){
    if(! example){
      return
    }
    let temp = this.proposedDates += "\n" + example
    temp = temp.trim()
    this.proposedDates = temp
  }

  get theSchedulingSheetId(){
    return this.$route.params.schedulingId || ''
  }

  get theSchedulingSheetDoc(){
    return doc(this.$getSchedulingSheetsColRef(),this.theSchedulingSheetId)
  }

  proposedDates = ''

  @Watch('proposedDates')
  updateProposedDates(current: string, prev: string){
    if(current === prev){
      return
    }
    let temp = current
    temp = toHanAscii(temp)
    temp = temp.replaceAll(/(\d{2})t/gm,'$1T')
    this.proposedDates = temp
  }

  get deployedDates(){
    const dt = DateTime.now().setZone(this.timeZone)
    const thisYear = dt.toFormat('yyyy')
    const nextYear = dt.plus({ year: 1}).toFormat('yyyy')
    const thisMonth = dt.toFormat('LL')
    const nextMonth = dt.plus({month: 1}).toFormat('LL')
    const nextYearMonth = dt.plus({ year: 1, month: 1}).toFormat('yyyyLL')
    /**
     * 今年今月dd日
     * dd
     * 今年dd月dd日
     * dddd
     * 20dd年dd月dd日
     * dddddd
     * dddd年dd月dd日
     * dddddddd
     */
    const dateTimeStrs = this.proposedDates.split(/\n+/)

    const dates: Array<{value: Date; line: number; comment: string}> = []

    dateTimeStrs.forEach((dateTimeCommentStr,line) => {
      try{
        if(! dateTimeCommentStr){
          return ''
        }

        const [dateTimeStr,commentStr] = dateTimeCommentStr.split('#')

        const [dateStr,timeStr] = dateTimeStr.split('T')

        if(! dateStr || ! timeStr){
          return ''
        }

        let matchDate
        let tempDateStr = ''
        const dateStrs: Array<{line: number;value: string}> = []

        if((matchDate = dateStr.match(/^(?<year>\d{4})(?<month>\d{2})(?<day>\d{2})/)) !== null){
          tempDateStr = matchDate[0]
          dateStrs.push({
            line: line,
            value: matchDate[0]
        })
        }else if((matchDate = dateStr.match(/^(?<year>\d{2})(?<month>\d{2})(?<day>\d{2})/)) !== null){
          tempDateStr = thisYear.substring(0,2) + matchDate[0]
          dateStrs.push({
            line: line,
            value: tempDateStr
          })
        }else if((matchDate = dateStr.match(/^(?<month>\d{2})(?<day>\d{2})/)) !== null){
          tempDateStr = thisYear + matchDate[0]
          if(dt > DateTime.fromISO(tempDateStr).setZone(this.timeZone)){
            tempDateStr = nextYear + matchDate[0]
          }
          dateStrs.push({
            line: line,
            value: tempDateStr
          })
        }else if((matchDate = dateStr.match(/^(?<day>\d{2})/)) !== null){
          tempDateStr = thisYear + thisMonth +  matchDate[0]
          if(dt > DateTime.fromISO(tempDateStr).setZone(this.timeZone)){
            tempDateStr = thisYear + nextMonth + matchDate[0]
          }
          if(dt > DateTime.fromISO(tempDateStr).setZone(this.timeZone)){
            tempDateStr = nextYearMonth + matchDate[0]
          }
          dateStrs.push({
            line: line,
            value: tempDateStr
          })
        }

        const currentYear = DateTime.fromISO(tempDateStr).setZone(this.timeZone).toFormat('yyyy')
        const currentMonth = DateTime.fromISO(tempDateStr).setZone(this.timeZone).toFormat('LL')

        if((matchDate = dateStr.match(/(?<start>\d{2})-(?<end>\d{2})$/)) !== null){
          for(let day = 1; day <=  Number.parseInt(matchDate[2]) - Number.parseInt(matchDate[1]);day++){
            tempDateStr = DateTime.fromISO(tempDateStr).setZone(this.timeZone).plus({day: 1}).toFormat('yyyyLLdd')
            dateStrs.push({
            line: line,
            value: tempDateStr
          })
          }
        }else{
          for(matchDate of dateStr.matchAll(/,(?<day>\d{2})/g)){
            tempDateStr = DateTime.fromISO(currentYear + currentMonth + matchDate[1]).setZone(this.timeZone).toFormat('yyyyLLdd')
            dateStrs.push({
            line: line,
            value: tempDateStr
          })
          }
        }

        const timeStrs: Array<string> = []

        let matchTime
        let tempTimeStr = ''

        if((matchTime = timeStr.match(/^(?<hour>\d{2})(?<min>\d{2})$/)) !== null){
          tempTimeStr = matchTime[0]
          timeStrs.push(matchTime[0])
        }else if((matchTime = timeStr.match(/^(?<hour>\d{2})$/)) !== null){
          tempTimeStr = matchTime[0] + '00'
          timeStrs.push(tempTimeStr)
        }else if((matchTime = timeStr.match(/(?<start>\d{2})-(?<end>\d{2})$/)) !== null){
          for(let hour = Number.parseInt(matchTime[1]); hour <=  Number.parseInt(matchTime[2]);hour++){
            tempTimeStr = ((hour < 10) ? '0' + hour.toString() : hour.toString())  + '00'
            timeStrs.push(tempTimeStr)
          }
        }else if((matchTime = timeStr.match(/(?<start>\d{2})-(?<end>\d{2})(?<min>\d{2})$/)) !== null){
          for(let hour = Number.parseInt(matchTime[1]); hour <=  Number.parseInt(matchTime[2]);hour++){
            tempTimeStr = ((hour < 10) ? '0' + hour.toString() : hour.toString())  + matchTime[3]
            timeStrs.push(tempTimeStr)
          }
        }else if(timeStr.includes(',')){
          let currentMin = '00'
          const hours = timeStr.split(',')
          const last = hours.pop()

          if(last){
            if(last.length === 4){
              hours.push(last.substring(0,2)) //last hour
              currentMin = last.substring(2,4)
            }else if(last.length === 2){
              hours.push(last)
            }
          }

          hours.forEach((hourStr) =>{
            tempTimeStr = hourStr + currentMin
            timeStrs.push(tempTimeStr)
          })
        }

        dateStrs.forEach((data) => {
          timeStrs.forEach((timeStr,index) => {
            const temp = data.value + 'T' + timeStr
            const m = DateTime.fromISO(temp).setZone(this.timeZone)
            if(m.diffNow().milliseconds > 0){
              dates.push(
                {
                  value: m.toJSDate(),
                  line: data.line,
                  comment: (index === 0 && commentStr) ? commentStr : ''
                }
              )
            }
          })
        })
      }catch(error){
        console.log(error)
      }
    })
    
    return dates.sort((a,b) => {
      return a.value.getTime() - b.value.getTime()
    })
  }

  get disabledAddScheduling(){
    return this.deployedDates.length === 0 ? true : false
  }

  defaultSchedulingSheet: SchedulingSheet = {
		title: '',
		comment: '',
		proposedDates: [],
		postStatus: 'draft'
	}

  schedulingSheet = {
    ...this.defaultSchedulingSheet
  }


  async editScheduling(){
		try{
			this.notice = {
				isShow: false,
			}

      if(await this.validationObserver.validate()){
        this.$store.commit("setLoading",true);
        this.isLoading = true
        
        const data: SchedulingSheet = {
          ...this.schedulingSheet,
          proposedDates: this.deployedDates
        }


        // eslint-disable-next-line
        const schedulingSheetDocRef = await this.$updateDoc(this.theSchedulingSheetDoc,data)
        
        this.notice = {
          message: this.$t('editScheduling.success') as string,
          isShow: true,
          duration: 0,
          type: {'is-success': true}
        }

        this.$nextTick(() =>{
          this.validationObserver.reset()
        })
      }
    }catch(error){
      console.table(error)
      const errorCode = this.$getErrorCode(error)

      const errorMessage0 = this.$t('addScheduling.error') as string
      const errorMessage1 = this.$t(this.$getErrorMessageKey(errorCode)) as string

      const errorMessage = (errorMessage1 === '') ? errorMessage0 : errorMessage0 + '<br />' + errorMessage1
      this.notice = {
        message: errorMessage,
        isShow: true,
        type: {'is-danger': true}
			}
			
    }finally{
      this.$store.commit("setLoading",false);
      this.isLoading = false
    }
  }

  get offset(){
    const timeZone = this.$timeZoneList.find((tz) => {return tz.name === this.timeZone})
    return timeZone ? timeZone.offset : ''
  }

  setEvents(){
    console.log('setEvents')
    this.calendarApi.batchRendering(() => {
      this.calendarApi.removeAllEvents()
      this.calendarApi.addEventSource(this.currentEvents)
    })
  }

  @Watch('Loading')
  changeLoading(newval: boolean){
    console.log('change Loading')
    //console.log(newval)
    //console.log(this.rawEvents.length)
    if(newval === false){
      console.log('loaded')
      this.setFilterOnEventsData()
      this.setEvents()
    }
  }

   setFilterOnEventsData(){
    this.currentEvents = this.rawEvents.map(event => {
      return event
    })
  }

  get updatedRawEvents(){
    console.log('updatedRawEvents')
    const time = Date.now()
    if(this.currentEvents.length !== this.rawEvents.length){
      console.log('length')
      return time
    }
    
    if(this.rawEvents.some((rEvent) => {
        return this.currentEvents.some((cEvent) => {
          return rEvent.id && (cEvent.id === rEvent.id) && rEvent.extendedProps.updateTime !== cEvent.extendedProps.updateTime})
       })){
        console.log('update')
      return time
    }

    if(this.rawEvents.some((rEvent) => {
        return this.currentEvents.every((cEvent) => {return cEvent.id !== rEvent.id})
       })){
        console.log('delele')
      return time
    }
    return 0
  }

  @Watch('updatedRawEvents',{immediate: true})
  changeUpdateRawEvents(updated: number){
    if(updated === 0){
      return
    }
    this.Loading = true
    const delay = 800
    window.clearTimeout(this.Timer)
    this.Timer = window.setTimeout(() => {
      this.Loading = false
    }, delay)
  }

  handleCalendarDatesSet(arg: DatesSetArg){
    console.log('change DatesSet')

    const startDate = arg.view.activeStart
    const endDate = arg.view.activeEnd

    this.rawEvents = []
    this.$unsubscriber(this.eventsObservers)

    const setEventData = (doc: QueryDocumentSnapshot<EventData>) => {
      const event = doc.data()
      const findIndex = this.rawEvents.findIndex(rawEvent => {return event.id === rawEvent.id})
      event.timeZone = event.timeZone ? event.timeZone : this.timeZone 
     
      if(findIndex === -1){
        this.rawEvents.push(event)
      }else{
        this.rawEvents.splice(findIndex, 1, event)
      }
    }

    try{
      const eventsStartQuery = query(this.$getEventsColRef(),orderBy('start','asc'),startAt(startDate),endBefore(endDate))

      const observerStart = onSnapshot(eventsStartQuery,(snapshot) => {
        snapshot.docs.forEach((doc) => {
          setEventData(doc)
        })
      })

      this.eventsObservers.push(observerStart)

      const eventsEndQuery = query(this.$getEventsColRef(),orderBy('end','asc'),startAfter(startDate),endAt(endDate))

      const observerEnd = onSnapshot(eventsEndQuery,(snapshot) => {
        snapshot.docs.forEach((doc) => {setEventData(doc)})
      })

      this.eventsObservers.push(observerEnd)
      
    }catch(error){
      console.log(error)
    }
    
  }

/*
  handleEventClick(arg: EventClickArg): void {
    console.log('eventClick')
  }
*/

  handleEventSelect(arg: DateSelectArg) {
    console.log('eventSelect')
    console.log(arg)
    const dt = DateTime.fromJSDate(arg.start,{zone: this.timeZone})
    let date = ''
    if(arg.allDay){
      date = dt.toFormat('yyyyLLdd') + 'T'
    }else{
      date = dt.toFormat('yyyyLLdd') + 'T' + dt.toFormat('HHmm')
    }

    if(date){
      this.proposedDates = this.proposedDates + "\n" + date
      this.proposedDates = this.proposedDates.trim()
    }
  }

  @Watch('timeZone')
  changeTimezone(newVal: string){
    console.log('change timeZone')
    this.calendarOptions.timeZone =  newVal
  }

  get lang(): string {
    return this.$store.getters.lang
  }

  @Watch('lang')
  changeLang(newVal: string){
    this.calendarOptions.locale = newVal
  }

  async created(){
    console.trace('created')
    try{
      this.timeZone = this.$defaultTimeZone

      try{
        const theSchedulingSheetDocData = await getDoc(this.theSchedulingSheetDoc)
        if(theSchedulingSheetDocData.exists()){
          this.schedulingSheet = {
            ...theSchedulingSheetDocData.data() as SchedulingSheet
          }
          this.proposedDates = this.schedulingSheet.proposedDates.map((proposedDate) => {
            console.log(proposedDate)
            const dt = DateTime.fromJSDate(proposedDate.value).setZone(this.timeZone)
            let line = dt.toFormat('yyyyLLdd') + 'T' + dt.toFormat('HHmm')
            if(proposedDate.comment){
              line += '#' + proposedDate.comment
            }
            return line
          }).join("\n")
        }else{
          throw Error()
        }
      }catch(error){
        this.notice = {
          message: this.$t('editScheduling.notFound') as string,
          isShow: true,
          duration: 0,
          type: {'is-danger': true}
        }
      }
   
      if(this.$store.state.userPrivateProfile.iCalendarUrl){
        const getCalendar = httpsCallable(functions,'getCalendar')
        const config: GetCalendarArg = {
          schoolId: this.$store.getters.schoolId,
          range: {
            start: new Date(),
            end:  DateTime.now().plus({year: 1}).toJSDate()
          }
        }
        const jcalData = await getCalendar(config) as {data: GetCalendarRes}
        //console.log(jcalData.data)
        this.iCalEvents = jcalData.data
        this.calendarApi.addEventSource(this.iCalEvents)
      }
    }catch(error){
          ///
    }
  }

  updated(){
    if(! this.unwatch && this.$refs.validationObserver){
      this.unwatch = this.$watch('$refs.validationObserver.flags',(flags: ValidationFlags) => {
        this.disabledEditSchedulingSheet = ! flags.changed
      })
    }
  }

  unwatch?: () => void

  mounted(){
   //const api = (this.$refs.fullCalendar as any).getApi()
    
  }

  destroyed() {
    this.$unsubscriber(this.eventsObservers)
  }
}
